// src/components/ServerDatabase/ServerHero.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServerHero = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="sdb-hero-wrap">
      <h1 className="sdb-hero-title">
        SERVER <span className="sdb-hero-title-accent">DATABASE</span>
      </h1>
      <p className="sdb-hero-subtitle">
        {isEn
          ? 'Browse our database of compromised servers ready for instant security testing and auditing.'
          : 'Просматривайте нашу базу данных доступных серверов для тестирования с мгновенным подключением.'}
      </p>
    </section>
  );
};

export default ServerHero;
